<template>
  <div class="public-profile">
    <div v-if="isNotFound"><p>Hmmm.. no app found</p></div>
    <div v-else-if="!isLoading">
      <h2>{{ appName }}</h2>
      <div v-if="hasMarketing">
        <p>{{ this.marketing }}</p>
      </div>
      <div v-if="hasLink"> 
        <a :href="link" target="_blank">{{ this.link }}</a>
      </div>
      <div v-if="hasContact">
        <h4>Contact:</h4>
        <p>{{ this.contact }}</p>
      </div>
      <div v-if="hasPP">
        <h4>Privacy policy:</h4>
        <p>{{ this.pp }}</p>
      </div>
    </div>
    <div v-else>loading...</div>
  </div>
</template>

<script>
import { database } from "../main";

export default {
  name: "PublicProfile",
  data() {
    return {
      id: "",
      isLoading: true,
      isNotFound: false,
      appName: "",
      link: "",
      marketing: "",
      contact: "",
      pp: "",
    };
  },
  computed: {
    hasLink: function () {
      return this.link.length > 0;
    },
    hasMarketing: function () {
      return this.marketing.length > 0;
    },
    hasContact: function () {
      return this.contact.length > 0;
    },
    hasPP: function () {
      return this.pp.length > 0;
    },
  },
  created: function () {
    this.id = this.$route.params.id;

    database
      .collection("users")
      .doc(this.id)
      .get()
      .then((doc) => {
        var data = doc.data();
        if (data) {
          this.appName = data["name"];
          this.link = data["url"];
          this.marketing = data["marketing"];
          this.contact = data["contact"];
          this.pp = data["pp"];
        } else {
          this.isNotFound = true;
        }

        this.isLoading = false;
      });
  },
};
</script>

<style scoped>
.public-profile {
  margin-top: 40px;
  margin-left: 40px;
  margin-right: 40px;
}
</style>